import {
  GroupSource,
  VariantPackCostChange,
} from '@sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';

export interface CategoryOption {
  displayName: string;
  source: GroupSource;
  uuid: string;
}

const SOURCE_ORDER: Record<GroupSource, number> = {
  ERP: 0,
  USER: 1,
};

export const deriveCategoryOptions = (
  rows: VariantPackCostChange[],
): CategoryOption[] => {
  const seen = new Set<string>();
  const options: CategoryOption[] = [];

  for (const row of rows) {
    for (const { displayName, source, uuid } of row.groups) {
      if (!seen.has(uuid)) {
        seen.add(uuid);
        options.push({ displayName, source, uuid });
      }
    }
  }

  return options.sort((a, b) => {
    const sourceDiff = SOURCE_ORDER[a.source] - SOURCE_ORDER[b.source];

    if (sourceDiff !== 0) {
      return sourceDiff;
    }

    return a.displayName.localeCompare(b.displayName, undefined, {
      sensitivity: 'base',
    });
  });
};
